'use strict';

angular.module('MoreDirectives', []);
